import {Menu, type MenuProps} from "antd";
import {MoonOutlined, SunOutlined} from "@ant-design/icons";
import {useState} from "react";
import {getSwitchedTheme, useThemeStore} from "../stores/ThemeStore.ts";

const SignInOut = () => {
  const {getTheme, switchTheme} = useThemeStore();
  // const {isAuth} = useAuthStore();
  const handleClick = () => {
    switchTheme(getSwitchedTheme());
  };

  const accountItems: MenuProps["items"] = [
    {
      label:
          getTheme() === "light" ? (
              <MoonOutlined className="text-base!"/>
          ) : (
              <SunOutlined className="text-base!"/>
          ),
      key: "theme",
      onClick: handleClick,
    },
    // (isAuth() ?
    //     {
    //       label: <Link to={"/logout"}><LogoutOutlined/><span>auth.sign.out</span></Link>,
    //       key: 'signout',
    //     } :
    //     {
    //       label: <Link to="/login"><LoginOutlined/><span>auth.sign.in</span></Link>,
    //       key: 'sign-in-out',
    //     }),
  ];

  const [accountMenuSelectedKeys, setAccountMenuSelectedKeys] = useState([""]);

  return (
      <Menu
          items={accountItems}
          mode="horizontal"
          className={"justify-end min-w-[140px]"}
          onChange={() => setAccountMenuSelectedKeys([""])}
          selectedKeys={accountMenuSelectedKeys}
      />
  );
};

export default SignInOut;
